import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'proposalDomainId',
                  },
                ],
              },
              modelId: 'ent:!proposal_domain:!entry',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
